import React from 'react';
import { Locations } from '../components/Locations';
export function Sedes() {
  return <div className="pt-24 md:pt-28" data-id="element-355">
      <Locations data-id="element-356" />
    </div>;
}